var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M13.672 1.262c-1.616 1.523-1.884 3.93-.766 5.746l-5.65 5.321c-1.763-1.208-4.193-1.073-5.81.45-1.857 1.75-1.936 4.665-.177 6.512 1.758 1.847 4.69 1.926 6.546.177 1.618-1.524 1.886-3.93.767-5.745l5.65-5.322c1.762 1.209 4.192 1.073 5.81-.45 1.856-1.75 1.936-4.665.177-6.512-1.759-1.847-4.69-1.927-6.547-.177",
    transform: "translate(.743 .555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M15.146 1.885c1.045-.985 2.656-.969 3.681.032.01.008.02.018.03.029.135.14.13.36-.012.493l-.002.002c-.138.13-.356.128-.49-.007-.754-.753-1.95-.77-2.724-.042-.14.134-.363.127-.496-.013-.135-.14-.128-.361.013-.494M2.92 13.402c1.045-.985 2.656-.969 3.681.032.011.01.021.018.03.029.135.14.13.36-.012.493l-.002.002c-.138.13-.356.128-.49-.007-.753-.753-1.95-.77-2.723-.042-.142.134-.364.127-.497-.013-.134-.14-.128-.361.013-.494M7.816 1.262c1.616 1.523 1.884 3.93.766 5.746l5.65 5.321c1.763-1.208 4.193-1.073 5.81.45 1.857 1.75 1.936 4.665.177 6.512-1.758 1.847-4.69 1.926-6.546.177-1.618-1.524-1.886-3.93-.767-5.745L7.256 8.4c-1.762 1.209-4.192 1.073-5.81-.45C-.41 6.2-.49 3.286 1.27 1.439c1.759-1.847 4.69-1.927 6.547-.177",
    transform: "translate(.743 .555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M6.356 2.38c-.134.14-.357.145-.497.013-.775-.73-1.971-.711-2.724.041-.134.134-.351.138-.49.007l-.003-.002c-.14-.133-.146-.353-.012-.494.01-.01.02-.02.031-.028C3.686.917 5.296.9 6.342 1.885c.141.132.147.354.014.494M18.581 13.896c-.133.14-.356.147-.496.014-.775-.73-1.97-.711-2.724.041-.134.134-.352.138-.49.007l-.002-.002c-.141-.133-.147-.353-.013-.494l.03-.028c1.026-1 2.637-1.017 3.682-.032.141.132.147.354.013.494",
    transform: "translate(.743 .555)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.c7a36217d19130e8dd8c63de9e63dfca.svg";
export { ForwardRef as ReactComponent };